import { useEffect } from "react";
import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@template/constants";
import { MODALS_NAMESPACE_KEY } from "./constants";
import { MODAL_TYPE } from "../constants";

export const usePublicApiManagement = openIFrameModal => {
  useEffect(() => {
    const asos_siteChrome =
      window[asosGlobalNamespace][siteChromeGlobalNamespace];

    asos_siteChrome[MODALS_NAMESPACE_KEY] = {};
    asos_siteChrome[MODALS_NAMESPACE_KEY].openIFrameModal = openIFrameModal;
    asos_siteChrome[MODALS_NAMESPACE_KEY].modalTypes = MODAL_TYPE;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
